export default function TrustSignals() {
  return (
    <div className="flex flex-col gap-y-2 pt-3 pb-4 border-t border-brand-primary-100">
      <div className="flex items-center gap-x-2.5 text-sm text-brand-primary-800">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M12.1174 4.46799C12.1174 3.95947 12.121 3.59416 12.0916 3.34099L12.0911 3.33675L12.0906 3.33299C12.0783 3.21111 12.0568 3.11235 12.0257 3.04441L12.0238 3.04017C12.0095 3.00807 11.9898 2.97867 11.9685 2.95826C11.9509 2.94145 11.931 2.92927 11.8993 2.92248C11.8684 2.9159 11.8437 2.91844 11.8172 2.92766C11.7866 2.93836 11.7544 2.95863 11.7256 2.98274C11.6632 3.0372 11.6012 3.1192 11.5428 3.21906L11.5409 3.22283L11.539 3.22612C11.4065 3.44532 11.245 3.78891 11.0341 4.23967L11.0337 4.24014L7.93575 10.844C7.60047 11.5598 7.34948 12.0942 7.22236 12.518L7.22188 12.5175C7.09841 12.934 7.09727 13.2413 7.26053 13.4995C7.433 13.7603 7.72056 13.8929 8.15764 13.9557L8.16003 13.9562C8.59698 14.0208 9.19716 14.0221 9.99625 14.0221H12.1174V19.5418C12.1174 19.9195 12.1151 20.2195 12.1264 20.4527L12.1426 20.6641L12.1431 20.6683L12.1436 20.6721C12.1559 20.7938 12.1775 20.8922 12.2085 20.9602L12.2109 20.9649C12.2252 20.9969 12.2445 21.0264 12.2658 21.0468C12.2833 21.0636 12.3032 21.0758 12.335 21.0826C12.3659 21.0892 12.3906 21.0866 12.417 21.0774C12.447 21.0669 12.4784 21.0471 12.5067 21.0237C12.568 20.9693 12.6293 20.8888 12.6866 20.7907L12.6886 20.7869L12.6905 20.7836C12.8229 20.5645 12.9845 20.2212 13.1953 19.7706L13.1958 19.7696L16.2937 13.1658L16.5285 12.6621C16.7466 12.1898 16.9117 11.8097 17.0071 11.4918C17.1311 11.0735 17.1322 10.7654 16.9665 10.5064L16.9336 10.4598C16.763 10.2333 16.4876 10.1131 16.0766 10.054L16.0742 10.0536C15.6372 9.98891 15.0371 9.98767 14.238 9.98767H12.1174V4.46799ZM13.2507 8.86914H14.238C15.001 8.86914 15.6995 8.86779 16.2393 8.94729H16.2398C16.7724 9.02381 17.4064 9.2171 17.8369 9.78383L17.9204 9.90246L17.9219 9.90434C18.3507 10.5701 18.2532 11.2735 18.0946 11.8076V11.809C17.9774 12.1998 17.7812 12.6479 17.5559 13.1352L17.3225 13.6351L14.2246 20.2394C14.0268 20.6623 13.8376 21.0672 13.6682 21.349C13.5801 21.4998 13.4466 21.6977 13.255 21.865L13.2483 21.8706C13.0411 22.0458 12.6301 22.2901 12.0949 22.1757C11.5591 22.0611 11.2879 21.6722 11.1735 21.4163V21.4159C11.0695 21.1865 11.0324 20.9498 11.0155 20.7836V20.7832C10.9776 20.4491 10.9836 19.9984 10.9836 19.5418V15.1406H9.99625C9.23299 15.1406 8.53436 15.1416 7.99445 15.062V15.0625C7.42504 14.9807 6.74483 14.7662 6.3114 14.1111L6.30758 14.1054C5.87874 13.4396 5.97623 12.7363 6.13484 12.2021V12.2007H6.13532C6.2916 11.6797 6.58747 11.0567 6.90693 10.3746L10.0048 3.77032C10.2043 3.34389 10.3946 2.93526 10.5651 2.65321C10.65 2.50895 10.7763 2.32417 10.954 2.16361L10.9697 2.14855L10.9859 2.13443C11.1931 1.95923 11.6041 1.71504 12.1393 1.82937C12.6722 1.94328 12.9433 2.32859 13.0588 2.58448L13.0956 2.6711C13.1723 2.87008 13.2026 3.06772 13.2178 3.21341C13.2567 3.54836 13.2507 4.00277 13.2507 4.46799V8.86914Z"
            fill="#0D8177"
            stroke="#0D8177"
            strokeWidth="0.3"
            strokeLinejoin="round"
          />
        </svg>
        <span>Fast delivery in 1-2 business days</span>
      </div>
      <div className="flex items-center gap-x-2.5 text-sm text-brand-primary-800">
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.0833 19.9192C10.362 20.0801 10.6782 20.1648 11 20.1648C11.3218 20.1648 11.638 20.0801 11.9167 19.9192L18.3333 16.2525C18.6118 16.0917 18.843 15.8606 19.0039 15.5823C19.1648 15.3039 19.2497 14.9882 19.25 14.6667V7.33333C19.2497 7.01183 19.1648 6.69607 19.0039 6.41772C18.843 6.13938 18.6118 5.90824 18.3333 5.74749L11.9167 2.08083C11.638 1.91992 11.3218 1.83521 11 1.83521C10.6782 1.83521 10.362 1.91992 10.0833 2.08083L3.66667 5.74749C3.38824 5.90824 3.15698 6.13938 2.99609 6.41772C2.8352 6.69607 2.75033 7.01183 2.75 7.33333V14.6667C2.75033 14.9882 2.8352 15.3039 2.99609 15.5823C3.15698 15.8606 3.38824 16.0917 3.66667 16.2525L10.0833 19.9192Z"
            stroke="#0D8177"
            strokeWidth="1.375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 20.1667V11"
            stroke="#0D8177"
            strokeWidth="1.375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.01562 6.41663L10.9998 11L18.984 6.41663"
            stroke="#0D8177"
            strokeWidth="1.375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.875 3.91418L15.125 8.63502"
            stroke="#0D8177"
            strokeWidth="1.375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span>Discreet packaging</span>
      </div>
      <div className="flex items-center gap-x-2.5 text-sm text-brand-primary-800">
        <svg
          width="22"
          height="22"
          aria-hidden="true"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.3332 11.9166C18.3332 16.5 15.1248 18.7916 11.3115 20.1208C11.1118 20.1885 10.8949 20.1852 10.6973 20.1116C6.87484 18.7916 3.6665 16.5 3.6665 11.9166V5.49996C3.6665 5.25685 3.76308 5.02369 3.93499 4.85178C4.1069 4.67988 4.34006 4.5833 4.58317 4.5833C6.4165 4.5833 8.70817 3.4833 10.3032 2.08996C10.4974 1.92405 10.7444 1.83289 10.9998 1.83289C11.2553 1.83289 11.5023 1.92405 11.6965 2.08996C13.3007 3.49246 15.5832 4.5833 17.4165 4.5833C17.6596 4.5833 17.8928 4.67988 18.0647 4.85178C18.2366 5.02369 18.3332 5.25685 18.3332 5.49996V11.9166Z"
            stroke="#0D8177"
            strokeWidth="1.375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.25 11L10.0833 12.8333L13.75 9.16663"
            stroke="#0D8177"
            strokeWidth="1.375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span>Secure checkout</span>
      </div>
    </div>
  );
}
